import React from 'react'

const IconGraphBtn = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.00008 11.5837V6.4972H11.5834V11.5837H9.00008ZM4.70842 11.5837V0.416992H7.29175V11.5837H4.70842ZM0.416748 11.5837V4.33699H3.00008V11.5837H0.416748Z" fill="#686867" />
    </svg>
  )
}

export default IconGraphBtn
